import { render, staticRenderFns } from "./StockSlipHistoryModal.vue?vue&type=template&id=580a3488&scoped=true"
import script from "./StockSlipHistoryModal.vue?vue&type=script&lang=js"
export * from "./StockSlipHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./StockSlipHistoryModal.vue?vue&type=style&index=0&id=580a3488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a3488",
  null
  
)

export default component.exports